import {Component, OnInit} from '@angular/core';
import { RealTimeService, ConnectionState } from '../../services/realtime.service';

@Component({
    moduleId: module.id,
    selector: 'connection-status',
    templateUrl: 'connection-status.component.html',
})
export class ConnectionStatus implements OnInit{

    isConnecting: boolean = true;
    status: string = "";

    constructor(private _signalrService: RealTimeService) {
    }

    public ngOnInit() {

        this._signalrService.connectionStateChanged.subscribe((state: any) => {

            if (state.newState == ConnectionState.connected) {
                this.status = "";
            }
            else {
                this.status = ConnectionState[state.newState];
            }
        });

        //this._signalrService.connectionEstablished.subscribe((started: Boolean) => {
        //    
        //    if (started) {

        //        this.isConnecting = false;
        //    }
        //    else {
        //        this.isConnecting = true;
        //    }
        //});
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/connectionStatus/connection-status.component.ts